import { Button, Card, Form, Input, message, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getSupabaseClient } from "../lib/supabase";

type ResetFormValues = {
	password: string;
	confirm: string;
};

export function ResetPasswordPage() {
	const navigate = useNavigate();
	const [checking, setChecking] = useState(true);
	const [submitting, setSubmitting] = useState(false);
	const [form] = Form.useForm<ResetFormValues>();

	useEffect(() => {
		void (async () => {
			const { data, error } = await getSupabaseClient().auth.getSession();
			if (error || !data.session) {
				message.error(
					"再設定用のセッションがありません。もう一度お試しください。",
				);
				navigate("/login", { replace: true });
				return;
			}
			setChecking(false);
		})();
	}, [navigate]);

	const onFinish = async (values: ResetFormValues) => {
		setSubmitting(true);
		try {
			const { error } = await getSupabaseClient().auth.updateUser({
				password: values.password,
			});
			if (error) {
				message.error(error.message);
				return;
			}
			message.success("パスワードを更新しました。");
			navigate("/users", { replace: true });
		} finally {
			setSubmitting(false);
		}
	};

	if (checking) {
		return (
			<div className="admin-login-page">
				<Typography.Text type="secondary">確認中…</Typography.Text>
			</div>
		);
	}

	return (
		<div className="admin-login-page">
			<Card className="admin-login-card" bordered={false}>
				<div className="admin-login-brand">たむたむ広場管理画面</div>
				<Typography.Title level={2} className="admin-login-heading">
					パスワード再設定
				</Typography.Title>
				<Form
					form={form}
					layout="vertical"
					requiredMark={false}
					onFinish={onFinish}
				>
					<Form.Item
						label="新しいパスワード"
						name="password"
						rules={[
							{ required: true, message: "パスワードを入力してください" },
							{ min: 8, message: "8文字以上で入力してください" },
						]}
					>
						<Input.Password
							size="large"
							placeholder="新しいパスワードを入力"
							autoComplete="new-password"
						/>
					</Form.Item>
					<Form.Item
						label="新しいパスワード（確認）"
						name="confirm"
						dependencies={["password"]}
						rules={[
							{ required: true, message: "確認用パスワードを入力してください" },
							({ getFieldValue }) => ({
								validator(_, value) {
									if (!value || getFieldValue("password") === value) {
										return Promise.resolve();
									}
									return Promise.reject(new Error("パスワードが一致しません"));
								},
							}),
						]}
					>
						<Input.Password
							size="large"
							placeholder="もう一度入力"
							autoComplete="new-password"
						/>
					</Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						block
						loading={submitting}
						className="admin-login-submit"
					>
						パスワードを更新
					</Button>
				</Form>
			</Card>
		</div>
	);
}
